import { createFileRoute, redirect } from '@tanstack/react-router'
import { NotificationPreferencesScreen } from '@/features/notifications/notification-preferences-screen'
import { hasGrant } from '@/lib/me'

/**
 * The preferences endpoints need `notification.edit` (b518); a role without
 * it would open a screen whose every request answers 403. Presentation only:
 * the API enforces the grant.
 */
export const Route = createFileRoute('/_authenticated/account/notifications')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'notification.edit')) {
      throw redirect({ to: '/account' })
    }
  },
  component: NotificationPreferencesScreen,
})
